import { dataLayer } from 'analytics/data-layer';
import { getCustomerId } from 'redux/modules/sessions/selectors';
import { isJointOrMyWaitroseMember } from 'redux/modules/marketing-preferences/selectors/get-membership-status';
import { generateCustomerEventForGTMDataLayer } from 'utils/gtm';
import { getCustomerHasACompletedOrder } from '../orders/selectors';

export const generateCustomerDataLayerEvent = (state, eventName) => {
  const membershipStatus = isJointOrMyWaitroseMember(state) ? 'Y' : 'N';
  const customerId = getCustomerId(state);
  const customerHasACompletedOrder = getCustomerHasACompletedOrder(state);

  return generateCustomerEventForGTMDataLayer(
    customerId,
    membershipStatus,
    customerHasACompletedOrder,
    eventName,
  );
};

export const callCustomerDataLayerEvent = (...args) => {
  const customerDataLayerEvent = generateCustomerDataLayerEvent(...args);
  dataLayer.push(customerDataLayerEvent);
};
